const yellowPrimary = "#f3cd06";
const yellowSecondary = "#e8bf13";
const black = "#222222";
const white = "#FFFFFF";

export { yellowPrimary, yellowSecondary, black, white };
